import { createAction, props } from '@ngrx/store';

export class TrackingToggleActions {
  static onToggle = createAction('[TrackingToggleActions] on toggle', props<{ wasSelected: boolean }>());
}
